import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import { VSnackbar, VBtn, VIcon } from 'vuetify/lib'
import ru from 'vuetify/lib/locale/ru'
import VuetifyToast from 'vuetify-toast-snackbar'
import VuetifyConfirm from 'vuetify-confirm'

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon
  }
});

Vue.use(VuetifyToast, {
  x: 'right',
  y: 'top',
  color: 'info',
  icon: 'fa-info',
  iconColor: '',
  classes: [
    'body-2'
  ],
  timeout: 3000,
  dismissable: true,
  multiLine: false,
  vertical: false,
  queueable: false,
  showClose: false,
  closeText: '',
  closeIcon: 'fa-times',
  closeColor: '',
  slot: [],
  shorts: {
    custom: {
      color: 'purple'
    }
  },
  property: '$toast'
})

const vuetify = new Vuetify({
  lang: {
    locales: { ru },
    current: 'ru',
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#ff9630",
        secondary: "#464e5f",
        accent: "#5d78ff",
        error: "#dc3545",
        info: "#17a2b8",
        success: "#28a745",
        warning: "#ffc107"
      }
    }
  }
});

Vue.use(VuetifyConfirm, { vuetify })

export default vuetify